import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, Phone, Mail, MapPin, Printer } from 'lucide-react';

const Footer = () => {
  const navigationLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Why Us', path: '/why-us' },
    { name: 'Our Services', path: '/services' },
    { name: 'Criminal Law', path: '/criminal' },
    { name: 'Office Location', path: '/location' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const serviceLinks = [
    { name: 'Visa & Immigration', path: '/services#visa' },
    { name: 'Work Permits', path: '/services#work-permits' },
    { name: 'Company Registration', path: '/services#company' },
    { name: 'Thai Property Law', path: '/services#property' },
    { name: 'Divorce & Family Law', path: '/services#family' },
    { name: 'Will and Testament', path: '/services#will' }
  ];

  return (
    <footer className="bg-[#000A22] text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <div className="w-12 h-12 bg-[#D4A74A] rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Scale className="w-7 h-7 text-[#000A22]" />
              </div>
              <div>
                <div className="text-xl font-bold">Pattaya Solicitors</div>
                <div className="text-xs text-[#D4A74A]">Legal Excellence in Thailand</div>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Premier law firm in Pattaya offering comprehensive legal services to domestic and foreign clients. Registered with the Lawyer's Council of Thailand.
            </p>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D4A74A]">Navigation</h3>
            <ul className="space-y-2">
              {navigationLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-[#D4A74A] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D4A74A]">Legal Services</h3>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-[#D4A74A] transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D4A74A]">Contact Us</h3>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4A74A] flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  20/173, Moo 10, South Pattaya Road,<br />
                  Pattaya City, Nongprue, Banglamung,<br />
                  Chonburi 20150
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#D4A74A] flex-shrink-0 mt-0.5" />
                <div className="text-gray-400">
                  <a href="tel:+6638412415" className="hover:text-[#D4A74A] transition-colors block">
                    +66 (38) 412-415
                  </a>
                  <a href="tel:+66818383869" className="hover:text-[#D4A74A] transition-colors block">
                    +66 (81) 838-3869
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#D4A74A] flex-shrink-0 mt-0.5" />
                <a 
                  href="mailto:info@pattayasolicitors.com"
                  className="text-gray-400 hover:text-[#D4A74A] transition-colors"
                >
                  info@pattayasolicitors.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2026 Pattaya Solicitors – DMC Inter Law – All Rights Reserved</p>
            <p>Registered with the Lawyer's Council of Thailand</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
